import { jsx as _jsx } from "react/jsx-runtime";
const RecordRow = ({ children, orientation }) => {
    const classNames = ['flex', 'flex-1', 'list-none', 'justify-around'];
    if (orientation === 'row')
        classNames.push('flex-row');
    else if (orientation === 'column')
        classNames.push('flex-col');
    return _jsx("ul", { className: classNames.join(' '), children: children });
};
export default RecordRow;
